import type { ResourcesConfig } from 'aws-amplify';
import { Amplify } from 'aws-amplify';

// Environment variables with fallbacks appropriate for staging
const config = {
    region: process.env.REACT_APP_REGION || 'us-east-1',
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
    cognitoDomain: process.env.REACT_APP_COGNITO_DOMAIN || 'stg-total-bat-auth.smndiaye.com',
    apiEndpoint: process.env.REACT_APP_API_ENDPOINT || 'https://api.smndiaye.com',
    s3Bucket: process.env.REACT_APP_S3_BUCKET || 'total-bat-frontend',
    domain: process.env.REACT_APP_DOMAIN || 'total-bat.smndiaye.com',
};

// Validate required configuration
const requiredConfig = ['userPoolId', 'userPoolClientId'] as const;
const missing = requiredConfig.filter((k) => !config[k]);
if (missing.length > 0) {
    // Fail early to surface configuration issues during boot
    // eslint-disable-next-line no-throw-literal
    throw new Error(
        `Missing required AWS configuration. Please set: ${missing.join(', ')}`
    );
}

const awsConfig: ResourcesConfig = {
    Auth: {
        Cognito: {
            userPoolId: config.userPoolId!,
            userPoolClientId: config.userPoolClientId!,
            signUpVerificationMethod: 'code',
            loginWith: {
                oauth: {
                    domain: config.cognitoDomain,
                    scopes: ['email', 'openid', 'profile'],
                    responseType: 'code',
                    providers: ['Google'],
                    redirectSignIn: [
                        'http://localhost:3001',
                        `https://${config.domain}`,
                        `https://${config.cognitoDomain}/oauth2/idpresponse`,
                    ],
                    redirectSignOut: [
                        'http://localhost:3001',
                        `https://${config.domain}`,
                        `https://${config.cognitoDomain}`,
                    ],
                },
            },
        },
    },
    API: {
        REST: {
            api: {
                endpoint: config.apiEndpoint,
                region: config.region,
            },
        },
    },
    Storage: {
        S3: {
            bucket: config.s3Bucket,
            region: config.region,
        },
    },
};

Amplify.configure(awsConfig);

export default awsConfig;



